import React from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

function resolveSrc(picture) {
  if (!picture) return null;
  if (picture.startsWith('http://') || picture.startsWith('https://')) {
    return picture;
  }
  if (picture.startsWith('/')) {
    return `${API}${picture}`;
  }
  return picture;
}

export default function Avatar({ name, picture, size = 'md', className = '', testId }) {
  const src = resolveSrc(picture);
  const sizeClasses = {
    xs: 'w-8 h-8 text-xs',
    sm: 'w-10 h-10 text-sm',
    md: 'w-12 h-12 text-base',
    lg: 'w-16 h-16 text-xl',
    xl: 'w-24 h-24 text-3xl',
  };
  const initial = (name || '?').charAt(0).toUpperCase();

  if (src) {
    return (
      <img
        src={src}
        alt={name || 'Avatar'}
        data-testid={testId}
        className={`${sizeClasses[size]} rounded-full object-cover border-2 border-white shadow-sm ${className}`}
        onError={(e) => {
          e.target.onerror = null;
          e.target.style.display = 'none';
          if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
        }}
      />
    );
  }

  return (
    <div
      data-testid={testId}
      className={`${sizeClasses[size]} rounded-full bg-gradient-to-br from-[#1E3A5F] to-[#2A4A6F] text-white font-bold flex items-center justify-center flex-shrink-0 ${className}`}
    >
      {initial}
    </div>
  );
}
